import axios from 'axios';
import { BACKEND_CLIENT_ID, BACKEND_GRANT_TYPE, LOGIN_URL } from '../../constants/api.constants';

export const signInWithEmailAndPassword = async (email: string, password: string) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    const payload = {
        client_id: BACKEND_CLIENT_ID,
        grant_type: BACKEND_GRANT_TYPE,
        username: email,
        password: password
    };

    try {

        const { data } = await axios.post(
            LOGIN_URL,
            payload,
            config
        );

        return data['access_token'];

    } catch (err: any) {
        if (err.status === 500) {
            err.message = 'Errore server';
        }

        if (err?.response?.data?.error === 'invalid_grant') {
            err.response.data.error_description = 'Credenziali non valide';
        }

        throw err;

    }
};